/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GetSharingParams = zod.object({
  performAsPrincipalType: zod
    .enum(['USER', 'GROUP', 'GROUP_MEMBER'])
    .optional()
    .describe(
      'Read the roster acting as this principal, as performAs on POST \/content\/share. Omitted: as the authenticated principal. A group’s manager passes GROUP to see the roster of what the group wrote.',
    ),
  performAsActorUuid: zod.uuid().optional().describe('The group, for GROUP or GROUP_MEMBER.'),
});

export type GetSharingParams = zod.input<typeof GetSharingParams>;
export type GetSharingParamsOutput = zod.output<typeof GetSharingParams>;
